import { render, staticRenderFns } from "./PSUOfficer.vue?vue&type=template&id=a2d4b82a&scoped=true&"
import script from "./PSUOfficer.vue?vue&type=script&lang=js&"
export * from "./PSUOfficer.vue?vue&type=script&lang=js&"
import style0 from "./PSUOfficer.vue?vue&type=style&index=0&id=a2d4b82a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d4b82a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDivider,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VRow})
